/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerFindAllQueryResponse, UserControllerFindAllQueryParams, UserControllerFindAll401, UserControllerFindAll403 } from "../../models/usersController/UserControllerFindAll";

function getUserControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/users` as const }  
  return res
}

/**
 * @summary Get all users with their roles
 * {@link /api/v1/users}
 */
export async function userControllerFindAll(params?: UserControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UserControllerFindAllQueryResponse, ResponseErrorConfig<UserControllerFindAll401 | UserControllerFindAll403>, unknown>({ method : "GET", url : getUserControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}